export default __webpack_public_path__ + "assets/tree.f8417813.svg";